import React from "react";
import {Button, Col, Row} from "antd";
import ctaImage from "../../../assets/images/backgrounds/cta_bg_small.jpeg";
import logo from "../../../assets/images/logo/logotype_white.png";
import styles from './index.module.scss';

const CallToAction = () => {
  return (
    <Row>
      <Col
        className={styles.ctaTextCol}
        xs={24}
        lg={12}
      >
        <div className={styles.textWrapper}>
          <a
            href="https://myedu.it/"
            title="MyEDU"
            target="_blank"
          >
            <img
              className={styles.logo}
              src={logo}
              alt="logo"
            />
          </a>
          <h1 className={styles.ctaTitle}>Richiedi il corso di italiano per bambini stranieri</h1>
          <p>
            Con l’obiettivo di agevolare l’integrazione di bambine e bambini stranieri nelle scuole italiane, MyEdu
            mette a disposizione il corso di italiano per stranieri per la scuola primaria. Le istituzioni scolastiche,
            gli enti o le associazioni italiane e con sede in Italia, possono compilare il form qui sotto per
            richiederne l’accesso.
          </p>
          <a href="#compila-il-form">
            <Button
              size="large"
              className={styles.ctaBtn}
            >
              <span className={styles.ctaBtnTextWrapper}>
                Richiedi l'accesso gratuito al corso
              </span>
            </Button>
          </a>
        </div>
      </Col>
      <Col xs={24} lg={12}>
        <img
          src={ctaImage}
          className={styles.ctaImage}
          alt="classe elementari"/>
      </Col>
    </Row>
  )
}

export default CallToAction;